import { Box } from '@mantine/core';
import FileThumbnail from 'components/files/FileThumbnail';
import Slider from 'components/modals/slider/Slider';
import { UserRow } from 'components/tables/data/user/types';
import { useDisclosure } from '@mantine/hooks';

/**
 * Column for the user's signature.
 */
export default function SignatureColumn({ data: { signatureFileId } }: { data: UserRow }) {
  const [sliderOpened, { open: openSlider, close: closeSlider }] = useDisclosure(false);

  if (!signatureFileId) {
    return <Box w={60} h={60} miw={60} mih={60} />;
  }

  return (
    <Box p={8} w={60} h={60} miw={60} mih={60}>
      <FileThumbnail fileId={signatureFileId} onOpenSlider={openSlider} />
      <Slider
        opened={sliderOpened}
        fileIds={[signatureFileId]}
        onClose={closeSlider}
        initialImageId={signatureFileId}
      />
    </Box>
  );
}
